import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import JSONViewer from 'react-json-viewer';
import LabelValueCard from './LabelValueCard';
import moment from 'moment';
import { backendDateFormat, displayDateTimeFormatShort } from '../../constants';
import { revisionInItem, revisionFieldList, getRevisionDisplayValue } from '../../shared/components';

const restoreSkipFields = ['id', 'console_id', 'lessor_id', 'created_at', 'created_by', 'updated_at', 'updated_by', 'deleted_at', 'deleted_by'];

const RevisionAddCard = ({ item }) => {
  const isRestore = item?.additional_data?.event === 'restored';
  const actionLabel = isRestore ? 'Reverted' : item?.action === 2 ? 'Deleted' : 'Created';
  const allowedFields = revisionFieldList[item?.content_type];
  const changes = Object.fromEntries(Object.entries(item?.changes || {}).filter(([k]) =>
    (!allowedFields || allowedFields.includes(k)) && !(isRestore && restoreSkipFields.includes(k))
  ));
  const formatLabel = key => {
    const upperWords = ['tsn', 'csn', 'tslsv', 'cslsv', 'cta', 'egt', 'tso', 'cso', 'tslpr', 'prsv', 'cslpr', 'mtbr', 'msn', 'esn'];
    return key?.split('_')?.map(word => upperWords.includes(word?.toLowerCase()) ? word?.toUpperCase() : word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
  };

  const formatValue = value => {
    if (!value) return '--';

    const m = moment(value, moment.ISO_8601, true);
    return m.isValid() ? m.format('MMMM DD, YYYY') : value;
  };

  return (
    <Fragment>
      <Grid container spacing={3}>
        <LabelValueCard md={6} label={`${actionLabel} at`} value={moment(item.timestamp).format(displayDateTimeFormatShort)} />
        <LabelValueCard md={6} label={`${actionLabel} by`} value={item.user && item.user.name ? item.user.name : '--'} />
        {
          item?.content_type && item?.object_repr ?
            <Grid md={6} className={'label-value-card'} style={{ margin: '0px 0px 20px 13px' }}>
              <p>  Revision In</p>
              <h6>{`${revisionInItem[item?.content_type]} (${item?.object_repr})`}</h6>
            </Grid>
            : null
        }
      </Grid>
      {allowedFields ?
        <div className="edit-detail-table">
          <table>
            <thead>
              <tr>
                <th style={{ width: '50%' }}>Label</th>
                <th style={{ width: '50%' }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(changes).map(([key, value]) =>
                <tr key={key}>
                  <td>{formatLabel(key)}</td>
                  <td>{getRevisionDisplayValue(item?.content_type, key, value) || (value === 'None' ? (isRestore ? '' : '--') : formatValue(value))}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div> :
      !['amutilization', 'amarchivedreports'].includes(item?.content_type) && (
        <div className="edit-detail-table">
          <JSONViewer json={Object.fromEntries(Object.entries(changes).map(([k, v]) => [formatLabel(k), Array.isArray(v) ? v.map(formatValue) : formatValue(v)]))} />
        </div>
      )}
    </Fragment>
  )
}
export default RevisionAddCard;
